import React, { useEffect } from 'react'
import styled from 'styled-components'
import api from '../../api'
import Responsive from '../../assets/config/Responsive'
import Colors from '../../assets/styles/Colors'
import { Container } from '../../assets/styles/GlobalStyle'
import Loader from '../../components/Loader'
import PlayStores from '../../components/PlayStores'
import { FaqTypes } from '../../domain/types'
import AccordionWithBackground from '../../components/v2/accordions/AccordionWithBackground'
import FindAnswerBanner from '../../components/v2/FindAnswerBanner'
import { Helmet } from 'react-helmet-async'
import { AppState } from '../../store/appSlice'
import { useAppSelector } from '../../store'
import { useTranslation } from 'react-i18next'
//
//
const FAQ = () => {
  //
  const { t } = useTranslation()
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { data, isLoading } = api.useGetWebPageQuery('faq')
  //
  const FaqData: FaqTypes = data as FaqTypes
  //
  // main page text list query
  const { data: mainpageTextList, isLoading: isMainPageTextLoading } = api.useGetMainPageTextListQuery(undefined)
  //
  const MainLoading = isMainPageTextLoading || isLoading
  //
  // scroll to top
  useEffect(() => {
    window.scrollTo(0, 0)
    //
    return () => {}
  }, [])
  //
  //
  return MainLoading ? (
    <Loader />
  ) : (
    <Container>
      {/* FOR SEO */}
      <Helmet>
        <title>FAQ</title>
        <meta name="description" content={`${t('faqSeoDescription')}`} />
        <link rel="canonical" href={window.location.href} />
      </Helmet>
      {/* FOR SEO */}
      <Wrapper>
        <Title>{FaqData.translations?.[lang]?.title}</Title>
        <AccordionBlock>
          {FaqData &&
            FaqData?.children?.map((item, index) => (
              <AccordionWithBackground
                key={index}
                title={item?.translations?.[lang]?.title}
                openAccordion={index === 0 ? true : false}
                className="accordion-wrapper"
              >
                <Description>{item?.translations?.[lang]?.body}</Description>
              </AccordionWithBackground>
            ))}
        </AccordionBlock>

        <FindAnswerBanner />

        <DownloadSection>
          <Container>
            <ServiceHead>
              <h1>
                {mainpageTextList?.find((item) => item.slug === 'main-page-fourth-block')?.translations?.[lang]?.title}
              </h1>
              <p>
                {
                  mainpageTextList?.find((item) => item.slug === 'main-page-fourth-block')?.translations?.[lang]
                    ?.excerpt
                }
              </p>
            </ServiceHead>
            <PlayStores />
          </Container>
        </DownloadSection>
      </Wrapper>
    </Container>
  )
}
//
//
const ServiceHead = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 65px;
  position: sticky;
  z-index: 1;
  /* TItle */
  h1 {
    /* font-size: 36px; */
    font-size: 20px;
    color: ${Colors.Black};
    margin-bottom: 35px;
    text-align: center;
  }
  /* description */
  p {
    font-size: 18px;
    color: ${Colors.SilverChalice};
    margin-bottom: 35px;
    width: 50%;
    text-align: center;
  }
  ${Responsive.mobile} {
    margin-bottom: 30px;
    /* TItle */
    h1 {
      font-size: 18px;
      margin-bottom: 16px;
    }
    /* description */
    p {
      font-size: 12px;
      margin-bottom: 0px;
      width: 100%;
    }
  }
`
const DownloadSection = styled.section`
  background-color: ${Colors.white};
  /* z-index: 1; */
  position: sticky;
  padding-top: 85px;
  padding-bottom: 85px;
  position: relative;
  overflow-y: hidden;
  user-select: none;
  pointer-events: none;
  ${Responsive.mobile} {
    padding-top: 30px;
    padding-bottom: 40px;
  }
`
const Description = styled.div`
  font-size: 14px;
`
const AccordionBlock = styled.div`
  .accordion-wrapper {
    :last-child {
      .accordion-head {
        border: none;
      }
    }
  }
`
const Title = styled.h2`
  font-size: 48px;
  text-align: center;
  color: ${Colors.primaryBlack};
  margin-bottom: 65px;

  ${Responsive.tablet} {
    margin-bottom: 32px;
  }
  ${Responsive.mobile} {
    margin-bottom: 32px;
  }
`
const Wrapper = styled.div`
  padding-block: 84px;

  ${Responsive.tablet} {
    font-size: 34px;
  }
  ${Responsive.mobile} {
    font-size: 34px;
  }
`
//
export default FAQ
